module.exports = __webpack_public_path__ + "img/693.2c908bdd.png";